var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 46,
    viewBox: "0 0 72 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7991 1.53935C22.2587 1.07972 23.0039 1.07972 23.4636 1.53935L43.7233 21.7991C44.183 22.2587 44.183 23.004 43.7233 23.4636L23.4636 43.7233C23.0039 44.183 22.2587 44.183 21.7991 43.7233L1.53934 23.4636C1.07971 23.004 1.07971 22.2587 1.53934 21.7991L11.6692 11.6692L21.7991 1.53935Z",
    fill: "none",
    stroke: "#3B4443"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4319 2.17069C35.8915 1.71107 36.6368 1.71107 37.0964 2.1707L57.3562 22.4305C57.8158 22.8901 57.8158 23.6353 57.3562 24.0949L37.0964 44.3547C36.6368 44.8143 35.8915 44.8143 35.4319 44.3547L15.1722 24.0949C14.7125 23.6353 14.7125 22.8901 15.1722 22.4305L25.302 12.3006L35.4319 2.17069Z",
    fill: "none",
    stroke: "#3B4443"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4319 2.17069C48.8915 1.71107 49.6368 1.71107 50.0964 2.1707L70.3562 22.4305C70.8158 22.8901 70.8158 23.6353 70.3562 24.0949L50.0964 44.3547C49.6368 44.8143 48.8915 44.8143 48.4319 44.3547L28.1722 24.0949C27.7125 23.6353 27.7125 22.8901 28.1722 22.4305L38.302 12.3006L48.4319 2.17069Z",
    fill: "none",
    stroke: "#3B4443"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.98ec2498e6e41646f28966efdcdf185d.svg";
export { ForwardRef as ReactComponent };